import React, { useState } from 'react';
import './Question.css';

const Question = ({ question, onAnswer, isTransitioning, questionNumber, onBack, showBack, backDisabled }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  if (!question) return null;

  const handleOptionClick = (option) => {
    if (question.multiSelect) {
      // Toggle option in multi-select
      const newSelected = selectedOptions.includes(option)
        ? selectedOptions.filter(o => o !== option)
        : [...selectedOptions, option];
      setSelectedOptions(newSelected);
    } else {
      // Single select - submit immediately
      onAnswer(option);
    }
  };

  const handleMultiSelectSubmit = () => {
    if (selectedOptions.length > 0) {
      onAnswer(selectedOptions);
      setSelectedOptions([]);
    }
  };

  return (
    <div className={`question ${isTransitioning ? 'transitioning' : 'active'}`}>
      <div className="question-number">Question {questionNumber}</div>
      
      <h2 className="question-text">{question.text}</h2>
      
      {question.tooltip && (
        <p className="question-tooltip">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="info-icon">
            <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M8 11V8M8 5H8.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          {question.tooltip}
        </p>
      )}

      <div className="options-grid">
        {question.options.map((option, index) => (
          <button
            key={index}
            className={`option-button ${question.multiSelect && selectedOptions.includes(option) ? 'selected' : ''}`}
            onClick={() => handleOptionClick(option)}
            disabled={isTransitioning}
            style={{ animationDelay: `${index * 0.05}s` }}
          >
            {question.multiSelect && (
              <span className="option-checkbox">
                {selectedOptions.includes(option) ? '✓' : ''}
              </span>
            )}
            <span className="option-text">{option}</span>
            {!question.multiSelect && (
              <svg className="option-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 16L4 10L10 4M4 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </button>
        ))}
      </div>

      <div className="button-footer">
        {showBack && (
          <button 
            className="back-button"
            onClick={onBack}
            disabled={backDisabled}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 16L4 10L10 4M4 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back
          </button>
        )}
        
        {question.multiSelect && (
          <button 
            className="continue-button"
            onClick={handleMultiSelectSubmit}
            disabled={selectedOptions.length === 0 || isTransitioning}
          >
            Continue
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 4L16 10L10 16M16 10H4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default Question;
